
import Vue from 'vue';
import { mapState } from 'vuex';
import { ANNOUNCEMENT_TYPE, Announcement } from '@run-diffusion/shared';
import {
	getAnnouncementsDismissed,
	setAnnouncementDismissed,
} from '@/utils/localStorage';

export default Vue.extend({
	name: 'AnnouncementsBanner',
	props: {
		previewAnnouncement: { type: Object, default: null },
	},
	data () {
		return {
			ANNOUNCEMENT_TYPE,
			dismissedAnnouncements: [] as string[],
		};
	},
	computed: {
		...mapState([
			'user',
			'announcements',
			'toolbar',
		]),
		visibleAnnouncements (): Announcement[] {
			// If previewAnnouncement is provided, use only that
			if (this.previewAnnouncement) {
				return [this.previewAnnouncement as Announcement];
			}
			
			// Otherwise, use announcements from Vuex state
			return (this.announcements || []).filter((announcement: Announcement) => {
				if (announcement.type === ANNOUNCEMENT_TYPE.NO_NEW_SESSIONS) return false;
				const isExpired: boolean = !!(
					announcement.expiresAt &&
					announcement.expiresAt.toDate() < new Date()
				);
				const isDismissed: boolean = this.dismissedAnnouncements.includes(announcement.message);
				return !isExpired && !isDismissed;
			});
		},
	},
	watch: {
		user: {
			immediate: true,
			handler (newVal) {
				if (newVal?.id) {
					this.loadDismissedAnnouncements();
				}
			},
		},
	},
	methods: {
		loadDismissedAnnouncements () {
			if (this.user?.id) {
				this.dismissedAnnouncements = getAnnouncementsDismissed(this.user.id);
			}
		},
		dismissAnnouncement (announcement: Announcement) {
			if (!this.previewAnnouncement) {
				setAnnouncementDismissed(announcement.message, this.user.id);
				this.dismissedAnnouncements = [...this.dismissedAnnouncements, announcement.message];
			}
		},
	},
});
